import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=cdd9ed04&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=ts"
export * from "./QuizPage.vue?vue&type=script&lang=ts"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=cdd9ed04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd9ed04",
  null
  
)

export default component.exports